// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { type SymbolInfoPriceSource } from '../charting_library';

export class TvSymbolInfoPriceSource implements SymbolInfoPriceSource {
    id: string;
    name: string;
}
